import PropTypes from "prop-types";
import { Navigate, useLocation, useParams } from "react-router-dom";

// An old page address: on to the new one, with its ids, ?search and #hash.
export function movedTarget(to, params, location) {
  const path = String(to).replace(/:([A-Za-z_]\w*)/g, (match, name) => (params[name] != null ? encodeURIComponent(params[name]) : match));
  return `${path}${location?.search || ""}${location?.hash || ""}`;
}

const Moved = ({ to }) => {
  const params = useParams();
  const location = useLocation();
  return <Navigate to={movedTarget(to, params, location)} replace />;
};

Moved.propTypes = { to: PropTypes.string.isRequired };

export default Moved;
